import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from "../db/db";

type ThemeContextType = {
  handleToggleTheme: () => void;
  theme: "light" | "dark";
};

export const ThemeContext = createContext<ThemeContextType>({
  handleToggleTheme: () => {},
  theme: "light",
});

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const userConfigsDb = useLiveQuery(() => db.userConfigs.toArray())
  const [theme, setTheme] = useState<"light" | "dark">(userConfigsDb?.[0]?.theme === 'Dark' ? 'dark' : 'light');

  useEffect(() => {
    const saved = userConfigsDb?.[0]?.theme;
    if (saved === "Dark") {
      setTheme("dark");
      document.documentElement.classList.add("dark");
    } else {
      setTheme("light");
      document.documentElement.classList.remove("dark");
    }
  }, [theme, userConfigsDb]);

  const handleToggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.classList.toggle("dark", newTheme === "dark");
  };

  const value = {
    handleToggleTheme,
    theme,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);